// XOFilterEditor sub actions
export const CONDITION_DRAFT_CHANGED = 'condition draft changed';
export const CONDITION_DRAFT_SAVED = 'condition draft saved';
export const CONDITION_DRAFT_ABANDONED = 'condition draft abandoned';
export const CONDITION_ADDED = 'condition added';
export const CONDITION_CLONED = 'condition cloned';
export const CONDITION_DELETED = 'condition deleted';
export const FILTER_LINK_CLICKED = 'filter link clicked';
export const SHOW_ALL_CONDITIONS_CLICKED = 'show all conditions clicked';
export const CHANGE_CRITERIA_CLICKED = 'change criteria clicked';

// SegmentationFilters sub actions
export const VIEWED_FILTERS = 'viewed filters';
export const VIEWER_CONDITION_EDIT = 'edit filter from viewer';
export const AND_GROUP_EDIT = 'opened AND group editor';
export const AND_GROUP_ADDED = 'clicked add filter group';
export const AND_GROUP_SAVED = 'saved AND group changes';
export const AND_GROUP_CLOSED = 'closed AND group editor';
export const AND_GROUP_CLONED = 'cloned AND group';
export const AND_GROUP_DELETED = 'deleted AND group';
export const VIEWER_CONDITION_DELETED = 'deleted filter from viewer';
export const VIEWER_CONDITION_ADDED = 'added filter from viewer';
export const EDITOR_CONDITION_ADDED = 'added filter from editor';
export const TEST_AN_OBJECT_OPENED = 'opened test an object';
export const TEST_AN_OBJECT_CLOSED = 'closed test an object';